export default {
  "Yes": "Yes",
  "No": "No",

  "Yes, I'm Sure": "Yes, I'm Sure",

  "Filter": "Filter",
  "Record": "Record",
  "deletedData": "Data successfully deleted",
  "dataAdded": "Data successfuly saved",
}
